/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const getChromeRuntime = () => chrome.runtime
